import { render, staticRenderFns } from "./RegistrationToStandardHeader.vue?vue&type=template&id=77624eb1&"
import script from "./RegistrationToStandardHeader.vue?vue&type=script&lang=js&"
export * from "./RegistrationToStandardHeader.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationToStandardHeader.vue?vue&type=style&index=0&id=77624eb1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports